import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the record table bonus report view.
 */
export default class recordTableBonusReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const vthis = this; // Reference to the current instance

        // Window for displaying filter details
        const filterDetails = webix.ui({
            view: 'window',
            move: true,
            id: 'filterDetails',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Historial'), align: 'center' }, // Title label
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close window on icon click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'datatable', // Data table for displaying details
                id: 'dtDetails',
                css: 'webix_header_border webix_data_border webix_footer_border',
                select: true,
                columns: [
                    {
                        id: 'detailTittle',
                        header: '',
                        width: 50,
                        height: 25,
                        tooltip: 'Detalles', // Tooltip for details column
                        template: function (obj) {
                            return "<span class='webix_icon wxi-close details'></span>"; // Icon template
                        },
                    },
                    { id: 'Id', header: 'ID', width: 100, sort: 'int' }, // ID column
                    { id: 'Date', header: _('Fecha'), width: 150, sort: 'int' }, // Date column
                    { id: 'Type', header: _('Tipo'), width: 150, sort: 'int' }, // Type column
                    {
                        id: 'Amount',
                        header: _('Monto'),
                        format: webix.i18n.priceFormat, // Formatting for amount
                        exportType: 'number',
                        width: 100,
                        sort: 'int',
                    },
                    {
                        id: 'Description',
                        header: _('Descripción'),
                        width: 200,
                        sort: 'int',
                    },
                ],
                onClick: {
                    details: function (euv, id) {
                        var item = this.getItem(id); // Get item on details click
                        vthis.app.callEvent('bonusTransDetail:select', [item]); // Trigger event with selected item
                        $$('detailsCasino').show(); // Show details view
                    },
                },
            },
        });

        // Main data table configuration
        return {
            view: 'datatable',
            css: 'webix_header_border webix_data_border webix_footer_border',
            select: true,
            columns: [
                {
                    id: 'detailTittle',
                    header: '',
                    width: 50,
                    height: 25,
                    tooltip: 'Detalles', // Tooltip for details column
                    template: function (obj) {
                        return "<span class='webix_icon wxi-close details'></span>"; // Icon template
                    },
                },
                { id: 'Id', header: 'ID', width: 100, sort: 'int' }, // ID column
                { id: 'Date', header: _('Fecha'), width: 150, sort: 'int' }, // Date column
                { id: 'Type', header: _('Tipo'), width: 150, sort: 'int' }, // Type column
                {
                    id: 'Amount',
                    header: _('Monto'),
                    format: webix.i18n.priceFormat, // Formatting for amount
                    exportType: 'number',
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'Description',
                    header: _('Descripción'),
                    width: 200,
                    sort: 'int',
                },
            ],
            onClick: {
                details: function (euv, id) {
                    var item = this.getItem(id); // Get item on details click
                    this.$scope.app.callEvent('bonusTransDetail:select', [item]); // Trigger event with selected item
                },
            },
            loadahead: 0, // Load ahead configuration
            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
            tooltip: true, // Enable tooltips
            pager: 'pagerA', // Pager configuration
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The data table grid instance.
     */
    init(grid) {
        const cur_user = this.getParam('user', true); // Get current user parameter
        var url = devConfig.geturlApi() + 'es/Report/GetClientBonusReportDetail'; // API URL for fetching report details

        // Event listener for user ID changes
        this.on(this.app, 'user:id', (idUser) => {
            grid.clearAll(); // Clear grid data
            grid.load(url + '?id=' + idUser); // Load grid data for the selected user
            $$('dtDetails').clearAll(); // Clear details data
            $$('dtDetails').load(url + '?id=' + idUser); // Load details data for the selected user
        });

        // Event listener for item clicks in the grid
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('bonusTransDetail:select', [item]); // Trigger event with selected item
        });
    }
}

// FILE DOCUMENTED
